// extracted by mini-css-extract-plugin
module.exports = {"header":"Header-header-2f7c","actions":"Header-actions-2f7c"};